<script setup lang="ts">
import VeeTextField from '@/components/forms/TextField/VeeTextField.vue';
import { mdiCalendar } from '@mdi/js';
import { maskitoDateOptionsGenerator } from '@maskito/kit';

const maskOptions = maskitoDateOptionsGenerator({
  mode: 'yyyy/mm/dd',
  separator: '-',
});

defineProps<{ name: string }>();
</script>

<template>
  <VeeTextField
    v-maskito="maskOptions"
    :name="name"
    :prependInnerIcon="mdiCalendar"
    :placeholder="$t('YearMonthDay')"
  />
</template>
